<!-- Actions button bar -->
<div class="action-bar mat-elevation-z2">
	<mat-toolbar>
		@if(checkValidity('DELETE')) {
		<button mat-raised-button color="warn" class="me-3 x-small-button" aria-label="Delete item" (click)="itemAction('DELETE')">
			{{ 'BUTTON.DELETE' | translate }}
		</button>
		}

		<div class="ms-auto d-flex me-2 align-items-center">
			@if(selectedItems.length) {
			<button mat-icon-button color="primary" class="unselect-button me-1"
					matTooltip="{{ 'ASSORTED.UNSELECT_ALL' | translate }}"
					matTooltipPosition="below"
					aria-label="Unselect all"
					(click)="itemAction('UNSELECT_ALL')">
				<mat-icon>close</mat-icon>
			</button>
			<span class="info-selected">{{ 'ASSORTED.SELECTED' | translate }}: {{ selectedItems.length }} \</span>
			}
			<span class="info-selected ms-1">{{ 'ASSORTED.TOTAL' | translate }}: {{ totalItemsCount }}</span>
		</div>

		@if(scrollToTop) {
		<button mat-icon-button color="primary" class="x-small-button" aria-label="Scroll to top" (click)="itemAction('SCROLL_TO_TOP')">
			<mat-icon>arrow_upward_alt</mat-icon>
		</button>
		}
	</mat-toolbar>
	<mat-divider></mat-divider>
</div>
<!-- (END) Actions button bar -->